import type { DropdownData } from '@fitogest/reactive-form-builder/interfaces';
import { list } from '@fitogest/reactive-form-builder/utils';
import { FincasModel } from 'src/app/models/form-common/fincas.module';
import { ParcelasModel } from 'src/app/models/form-common/parcelas.model';

export class SectoresListsDefinition {
  distanciasGoteros: DropdownData<string> =  list(
      ['...', null],
      '25cm',
      '30cm',
      '50cm',
      '95cm',
      '100cm'
  );

  fincas: DropdownData<FincasModel> = {
      filtered: [{label: '...', value: null}],
      values: []
  };

  jardines: DropdownData<ParcelasModel> = list<ParcelasModel>(['...', null]);
}
